import { render, staticRenderFns } from "./Jsgz.vue?vue&type=template&id=73e2de6f&scoped=true"
import script from "./Jsgz.vue?vue&type=script&lang=js"
export * from "./Jsgz.vue?vue&type=script&lang=js"
import style0 from "./Jsgz.vue?vue&type=style&index=0&id=73e2de6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e2de6f",
  null
  
)

export default component.exports